import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="font-body selection:bg-gold/20 selection:text-white">
      {/* Camada de grão fixa para textura premium */}
      <div className="grain-overlay" />

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>

      {/* Notificações do sistema */}
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
